import { inject, Injectable } from '@angular/core'
import { ToastController } from '@ionic/angular'

export interface PresentToastOpts {
  message: string
  cssClass?: string | string[]
  position?: 'bottom' | 'middle' | 'top'
  duration?: number
  icon?: string
}

/**
 * @deprecated Use PrimeNgToastService instead
 */
@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private toastCtrl = inject(ToastController)

  /** @deprecated Use PrimeNgToastService instead */
  async toast(opts: PresentToastOpts) {
    const toast = await this.toastCtrl.create({
      message: opts.message,
      duration: opts.duration,
      icon: opts.icon,
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          handler: () => {},
        },
      ],
      cssClass: opts.cssClass,
      position: opts.position,
    })
    await toast.present()
    return toast
  }
  /** @deprecated Use PrimeNgToastService instead */
  async simpleToast(message: string, position: 'bottom' | 'middle' | 'top' = 'bottom', duration = 3000) {
    const toast = await this.toastCtrl.create({
      message,
      duration,
      position,
    })
    await toast.present()
    return toast
  }

  /** @deprecated Use PrimeNgToastService instead */
  async errorToast(message: string) {
    return await this.toast({
      message,
      cssClass: 'error',
      icon: 'alert-circle-outline',
      duration: 10000,
      position: 'bottom',
    })
  }
}
